import { useCallback } from 'react';
import { Icon } from 'ui';

export type PostType = 'activity' | 'event' | 'poll' | 'post' | 'withings_order_post';

export const useHeaderPostImage = () =>
  useCallback((postType: PostType) => {
    switch (postType) {
      case 'activity':
        return <Icon color="primary" icon="activity" size="middle" />;
      case 'event':
        return <Icon color="primary" icon="event" size="middle" />;
      case 'poll':
        return <Icon color="primary" icon="poll" size="middle" />;
      case 'post':
        return <Icon color="primary" icon="post" size="middle" />;
      case 'withings_order_post':
        return <Icon color="primary" icon="withings-order-post" size="middle" />;
    }
  }, []);
